import { format } from 'date-fns';

var date_time_formats = {
    time: "hh:mm a",
    date_year_time: "MMMM dd, yyyy, hh:mm a",
    date_time: "MMMM dd, hh:mm a",
    date_year: "MMMM dd, yyyy",
    date_no_year: "MMMM dd",
};
var formatDateTime = function (date, options) {
    var _a, _b;
    var time = (_a = options === null || options === void 0 ? void 0 : options.showTime) !== null && _a !== void 0 ? _a : false;
    var year = (_b = options === null || options === void 0 ? void 0 : options.showYear) !== null && _b !== void 0 ? _b : false;
    if (time && year) {
        return format(date, date_time_formats.date_year_time);
    }
    else if (time) {
        return format(date, date_time_formats.date_time);
    }
    else if (year) {
        return format(date, date_time_formats.date_year);
    }
    else {
        return format(date, date_time_formats.date_no_year);
    }
};

export { formatDateTime };
//# sourceMappingURL=dateTime.js.map
